import { DownloadFile, Heading5, Icon } from "shared/components";

import styles from "./Item.module.scss";

export const Item = ({ title, attachmentButtonText, file }) => {
  return (
    <div className={styles.content}>
      <Icon className={styles.file} name="file" />
      <Heading5 className={styles.title}>{title}</Heading5>
      <DownloadFile
        file={file}
        label={attachmentButtonText}
        icon="arrow_right"
        color="blue"
        className={styles.label}
      />
    </div>
  );
};
